export default "__VITE_ASSET__C34YY0H1__"